module.exports = __webpack_public_path__ + "static/img/30002 (4).7b0f2e5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30002 (4).webp
// module id = Fo/n
// module chunks = 14